<!-- <img *ngIf="!logoPropi" src="/assets/images/HardmanLogoBlau.png" alt="Hardman logo"
            class="logo logosensenom"> -->
<img *ngIf="!logoPropi" src="/assets/images/HardmanLogoBlauNom.png" alt="Hardman logo" class="logo logoambnom">
<shared-image *ngIf="logoPropi" class="logo" [image]="logoImage">
</shared-image>